import Api from '../api';

export const createCard = (biddingId: number) =>
  Api.post('/gestao_ia/cards', { bidding_id: biddingId });

export const listCards = () => Api.get('/gestao_ia/cards');

export const moveCard = (id: number, columnId: number, afterCardId: number | null) =>
  Api.patch(`/gestao_ia/cards/${id}/mover`, {
    column_id: columnId,
    after_card_id: afterCardId,
  });

export const deleteCard = (id: number) => Api.delete(`/gestao_ia/cards/${id}`);
export const listArchivedCards = () => Api.get('/gestao_ia/cards/arquivadas');
export const archiveCard = (id: number) => Api.patch(`/gestao_ia/cards/${id}/arquivar`);
export const archiveCards = (cardIds: number[]) =>
  Api.patch('/gestao_ia/cards/arquivar', { card_ids: cardIds });
export const restoreCard = (id: number) => Api.patch(`/gestao_ia/cards/${id}/restaurar`);
export const restoreCards = (cardIds: number[], columnId?: number) =>
  Api.patch('/gestao_ia/cards/restaurar', {
    card_ids: cardIds,
    ...(columnId ? { column_id: columnId } : {}),
  });

export interface CardsMembersPayload {
  card_ids: number[];
  add_contact_client_ids: number[];
  remove_contact_client_ids: number[];
}

export const updateCardsMembers = (payload: CardsMembersPayload) =>
  Api.patch('/gestao_ia/cards/membros', payload);

export const addCardMember = (cardId: number, contactClientId: number) =>
  Api.post(`/gestao_ia/cards/${cardId}/membros`, { contact_client_id: contactClientId });

export const removeCardMember = (cardId: number, contactClientId: number) =>
  Api.delete(`/gestao_ia/cards/${cardId}/membros/${contactClientId}`);
